<template>
  <div class="market_coin">
    <div class="content_title">
      <div class="coin">{{ $t('币种') }}</div>
      <div class="price">{{ $t('最新价') }}</div>
      <div class="upDown">24H {{ $t('涨跌') }}</div>
      <div class="height">24H {{ $t('最高价') }}</div>
      <div class="low">24H {{ $t('最低价') }}</div>
      <div class="amount">24H {{ $t('成交量') }}</div>
    </div>
    <ul
      v-loading="loading"
      element-loading-background="rgba(0, 10, 34, 1)"
      class="content_content"
    >
      <li
        class="content_li"
        v-for="(item, index) in coinList"
        :key="index"
        @click="jumpToName('transaction', item)"
      >
        <p class="coin">{{ item.market | marketFilter }}</p>
        <p class="price">
          {{ item.price }}<span class="gray_text">≈¥{{ item.cny }}</span>
        </p>
        <p
          :class="
            Number(item.ratio) === 0
              ? 'smooth_white'
              : Number(item.ratio) > 0
              ? 'up_green'
              : 'down_red'
          "
          class="upDown"
        >
          {{ Number(item.ratio) > 0 ? '+' : '' }}{{ item.ratio }}%
        </p>
        <p class="height">{{ item.max }}</p>
        <p class="low">{{ item.min }}</p>
        <p class="amount">{{ item.amount }}</p>
      </li>
    </ul>
  </div>
</template>
<script>
import { SET_TRADING_PAIR_DATA } from '@/store/mutation-types'
export default {
  name: 'MainCoin',
  props: {
    loading: {
      type: Boolean
    },
    coinList: {
      type: Array,
      required: true
    }
  },
  methods: {
    jumpToName(name, item) {
      this.$store.commit(`transaction/${SET_TRADING_PAIR_DATA}`, item)
      this.$router.push({ name })
    }
  }
}
</script>
<style lang="less" scoped>
.market_coin {
  border: 1px solid #181e43;
  .content_title,
  .content_li {
    position: relative;
    padding: 7px 20px 7px 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    div {
      height: 17px;
      font-size: 14px;
      font-weight: 400;
      color: #b0b8db;
      line-height: 17px;
    }
  }
  .content_title {
    background: #0a0a0c;
  }
  .content_content {
    height: 200px;
    overflow-y: auto;
    .content_li {
      cursor: pointer;
      &:hover {
        background: #1e2238;
      }
      p {
        height: 20px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(176, 184, 219, 1);
        line-height: 20px;
        .gray_text {
          font-size: 14px;
          color: #707380;
        }
      }
      // 动态控制字体颜色
      .up_green {
        color: #41b37e;
      }
      .down_red {
        color: #ff3f4a;
      }
      .smooth_white {
        color: #707380;
      }
    }

    &::-webkit-scrollbar {
      display: none;
    }
  }
  .self {
    cursor: pointer;
  }

  .price {
    left: 180px;
    position: absolute;
  }
  .upDown {
    left: 400px;
    position: absolute;
  }
  .height {
    left: 600px;
    position: absolute;
  }
  .low {
    left: 800px;
    position: absolute;
  }
  .amount {
    left: 1000px;
    position: absolute;
  }
}
</style>
